import WarningAmber from "@mui/icons-material/WarningAmber";
import { Typography } from "@mui/material";
import { OrderListErrorsWarningMessage } from "constants/text";
import { OrderListErrorWarningWrapper } from "./OrderList.styles";

const OrderListErrorsWarning = () => {
	return (
		<OrderListErrorWarningWrapper>
			<WarningAmber />
			<Typography data-testid="order-list-errors-warning-message">{OrderListErrorsWarningMessage}</Typography>
		</OrderListErrorWarningWrapper>
	);
};

export default OrderListErrorsWarning;
